import { render } from "./InstitutionsResume.vue?vue&type=template&id=692c91f7"
import script from "./InstitutionsResume.vue?vue&type=script&lang=js"
export * from "./InstitutionsResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__